import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreCartService {

  constructor() { }

  NewCart() {
    let newCart = {
      orderTotal: null,
      products: []
    };
    return newCart;
  };

  newProductOrdered() {
    let product = {
      ProductID: null,
      CalculatedRealPrice: 0,
      Quantity: 0,
      Title: '',
      ProductImageID: 0,
      ProductSaleCost: 0
    }
    return product;
  };


  createNewCart() {
    return this.NewCart();
  };

  createNewProduct() {
    return this.newProductOrdered();
  };
}
